// Matches the backend company_name SlugField: 3-32 letters, numbers, hyphens or underscores.
export const validSlug = (value: string): boolean => {
  return /^[a-zA-Z0-9_-]{3,32}$/.test(value);
};

export const certificateWithComments = (value: string): boolean => {
  return value.includes('-----');
};

const ENTRA_LOGIN_HOST = 'login.microsoftonline.com';
const ENTRA_SAML_PATH_REGEX =
  /^\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/saml2\/?$/i;
const NON_SAML_PATH_MARKERS = ['/.well-known/', '/oauth2/'];

export const SAML_LOGIN_URL_INVALID_MSG = 'Enter a valid URL.';
export const SAML_LOGIN_URL_OIDC_MSG =
  'This is an OpenID Connect URL. Use your SAML sign-on URL ' +
  '(Entra ID: https://login.microsoftonline.com/<tenant-id>/saml2).';
export const SAML_LOGIN_URL_ENTRA_MSG =
  'Use https://login.microsoftonline.com/<tenant-id>/saml2 for Entra ID.';

// Mirrors validate_login_url in business-api, which stays the source of truth.
export const validateSamlLoginUrl = (value: string): string | null => {
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    return SAML_LOGIN_URL_INVALID_MSG;
  }
  // Same schemes Django's URLField accepts.
  if (!['http:', 'https:', 'ftp:', 'ftps:'].includes(url.protocol) || !url.hostname) {
    return SAML_LOGIN_URL_INVALID_MSG;
  }

  const path = url.pathname.toLowerCase();
  if (
    path.replace(/\/+$/, '').endsWith('/v2.0') ||
    NON_SAML_PATH_MARKERS.some((marker) => path.includes(marker))
  ) {
    return SAML_LOGIN_URL_OIDC_MSG;
  }

  if (url.hostname === ENTRA_LOGIN_HOST && !ENTRA_SAML_PATH_REGEX.test(url.pathname)) {
    return SAML_LOGIN_URL_ENTRA_MSG;
  }
  return null;
};
